import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=732f5efc&scoped=true"
import script from "./IconList.vue?vue&type=script&lang=js"
export * from "./IconList.vue?vue&type=script&lang=js"
import style0 from "./IconList.vue?vue&type=style&index=0&id=732f5efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f5efc",
  null
  
)

export default component.exports